import { render, staticRenderFns } from "./Correspondents.vue?vue&type=template&id=ccdfb95a&scoped=true&"
import script from "./Correspondents.vue?vue&type=script&lang=js&"
export * from "./Correspondents.vue?vue&type=script&lang=js&"
import style0 from "./Correspondents.vue?vue&type=style&index=0&id=ccdfb95a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdfb95a",
  null
  
)

export default component.exports